export default __webpack_public_path__ + "static/media/shoes2.cc3d42be.png";